import { useId } from 'react'
import { type IconProps, iconVariants } from './common'

export function LogoIcon({ className, size = 32, ...props }: IconProps) {
  const id = useId()
  const g = (n: number) => `${id}-logo-g-${n}`

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 128 128"
      fill="none"
      role="presentation"
      className={iconVariants({ size, className })}
      {...props}
    >
      <path d="M71.3077 123.273L65.5186 106.541H100.254L71.3077 123.273Z" fill={`url(#${g(0)})`} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64 96L119.36 32V59.5061L104.811 76.3262H119.36V96H64Z"
        fill={`url(#${g(1)})`}
      />
      <path d="M8.85156 41.4609L26.2191 44.8073L8.85156 74.9245V41.4609Z" fill={`url(#${g(2)})`} />
      <path
        d="M26.7435 106.465L8.63965 96L36.3196 48L63.9996 128L40.2438 114.268L33.4936 94.759L26.7435 106.465Z"
        fill={`url(#${g(3)})`}
      />
      <path d="M111.217 27.4955L99.6382 40.8809L82.2705 10.7637L111.217 27.4955Z" fill={`url(#${g(4)})`} />
      <path
        d="M91.6796 48L8.63965 32L30.104 19.5928L50.8486 23.5899L43.9337 11.5988L63.9996 0L91.6796 48Z"
        fill={`url(#${g(5)})`}
      />
      <path d="M59.4938 86.4636L46.5 48.7852L85.2728 56.3132L59.4938 86.4636Z" fill={`url(#${g(6)})`} />
      <defs>
        <linearGradient id={g(0)} x1="82.8862" y1="106.541" x2="82.8862" y2="123.273" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(var(--primary-600))" />
          <stop offset="1" stopColor="rgb(var(--primary-400))" />
        </linearGradient>
        <linearGradient id={g(1)} x1="91.68" y1="32" x2="91.68" y2="96" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(var(--primary-600))" />
          <stop offset="1" stopColor="rgb(var(--primary-400))" />
        </linearGradient>
        <linearGradient id={g(2)} x1="17.5353" y1="41.4609" x2="17.5353" y2="74.9245" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(var(--primary-600))" />
          <stop offset="1" stopColor="rgb(var(--primary-400))" />
        </linearGradient>
        <linearGradient id={g(3)} x1="36.3196" y1="48" x2="36.3196" y2="128" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(var(--primary-600))" />
          <stop offset="1" stopColor="rgb(var(--primary-400))" />
        </linearGradient>
        <linearGradient id={g(4)} x1="96.7436" y1="10.7637" x2="96.7436" y2="40.8809" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(var(--primary-600))" />
          <stop offset="1" stopColor="rgb(var(--primary-400))" />
        </linearGradient>
        <linearGradient id={g(5)} x1="50.1597" y1="0" x2="50.1597" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(var(--primary-600))" />
          <stop offset="1" stopColor="rgb(var(--primary-400))" />
        </linearGradient>
        <linearGradient id={g(6)} x1="65.8864" y1="48.7852" x2="65.8864" y2="86.4636" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(var(--primary-600))" />
          <stop offset="1" stopColor="rgb(var(--primary-400))" />
        </linearGradient>
      </defs>
    </svg>
  )
}
